<template>
  <div class="text_left">
    <title-bar-back
      v-if="this.$route.query.whereFrom !== 'app'"
      :title="'发货时间说明'"
      @back="back"
    >
      <div class="title_right"></div>
    </title-bar-back>
    <div class="exp_top text_center">(以下均为澳洲当地时间)</div>

    <div class="exp_bottom bot_bottom">
      <div class="font0">
        <img src="@/assets/order/icon_title@2x.png" alt="" class="title_img" />
        <span class="title_title">本地配送</span>
      </div>
      <div class="exp_item">
        现货商品通常在 48
        小时内安排发货。如有商品预售、周末及澳洲法定节假日停发、或商品限发区域等特殊情况，请以实际页面标注时间和系统下单提示为准。
      </div>
    </div>

    <div class="exp_bottom bot_bottom">
      <div class="font0">
        <img src="@/assets/order/icon_title@2x.png" alt="" class="title_img" />
        <span class="title_title">门店自提</span>
      </div>
      <div class="exp_item">
        下单并支付成功后，请在门店营业时间内前往指定地址提货。提货时请出示订单信息或提货码。如有特殊情况，建议提前与客服或门店联系确认。
      </div>
    </div>

    <div class="exp_bottom bot_bottom">
      <div class="font0">
        <img src="@/assets/order/icon_title@2x.png" alt="" class="title_img" />
        <span class="title_title">直邮</span>
      </div>
      <div class="exp_item">
        现货商品通常在 48 小时内安排发货。如遇商品预售、法定节假日停发、限发区域或海关清关延迟等特殊情况，发货及物流时效请以实际页面标注和系统提示为准。
      </div>
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then((m) => m.default || m);
export default {
  components: {
    TitleBarBack,
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.title_right {
  width: 36px;
}
.exp_top {
  font-size: 14px;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
  line-height: 35px;
  padding: 0 12px;
  background: #fff;
}
.exp_bottom {
  padding: 10px 15px 5px;
  background: #fff;
}
.title_img {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}
.title_title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(221, 145, 50, 1);
  line-height: 22px;
  margin-left: 5px;
  vertical-align: middle;
}
.exp_item {
  margin-top: 5px;
  font-size: 14px;
  color: #888;
  line-height: 24px;
}
.font_color1 {
  font-weight: 500;
  color: #222;
}
.bot_bottom {
  padding-bottom: 30px;
}
</style>
